module.exports = __webpack_public_path__ + "img/free-coins.fff46340.svg";